import { Link } from 'react-router-dom'
import { f2 } from '../../copyFlow2'
import type { Filters } from '../../lib/browse'
import { Plus } from '../../ui/icons'
import { buttonClass } from '../../ui/styles'

/** Create a plan, always on Browse (V2 B0): floats at the bottom, above the plan tray when it shows. */
export function CreatePlanButton() {
  return (
    <div className="fab-create pointer-events-none fixed inset-x-0 z-30 flex justify-center px-5 lg:justify-end lg:px-8">
      <Link to="/plan/new" data-review-id="create-plan-button" className={buttonClass('primary', 'lg', 'pointer-events-auto border border-bg px-6')}>
        <Plus size={18} />{f2('plan.create')}
      </Link>
    </div>
  )
}

/** Share a find (V2): a quiet door at the bottom of Browse to the existing /found screen. */
export function FoundDoor() {
  return (
    <section data-review-id="found-door" className="mt-12 border-t border-line pt-8">
      <span aria-hidden="true" className="rule-accent" />
      <h2 className="t-headline mt-4 text-ink">{f2('found.door_title')}</h2>
      <p className="t-body mt-1 text-ink-2">{f2('found.door_body')}</p>
      <Link to="/found" className={buttonClass('secondary', 'md', 'mt-4')}>{f2('found.door_action')}</Link>
      {/* QA prod r1 (B-050): what is kept about them, reachable from Browse on a phone too */}
      <p data-review-id="browse-legal" className="t-meta mt-8 flex gap-5 text-ink-2">
        <Link to="/settings" className="press inline-flex min-h-11 items-center underline underline-offset-4">{f2('nav.settings')}</Link>
        <Link to="/privacy" className="press inline-flex min-h-11 items-center underline underline-offset-4">{f2('common.privacy')}</Link>
      </p>
    </section>
  )
}

/** Zero results (V2 unhappy state): widen the distance and/or clear the filters, as the server's empty_reason says. */
export function EmptyActions({ reason, f, onWiden, onClear, onWidenPlan, atHome = false }: { reason?: string; f: Filters; onWiden: () => void; onClear: () => void; onWidenPlan?: () => void; atHome?: boolean }) {
  // a plan view keeps its distance in the plan, not the URL (review M5): widening re-sets the plan with no distance
  if (f.plan && reason === 'radius' && onWidenPlan) {
    return <div className="mt-4"><button type="button" onClick={onWidenPlan} className={buttonClass('primary', 'md')}>{f2('browse.widen')}</button></div>
  }
  const canWiden = (f.miles !== null || (atHome && !f.anyDist)) && reason !== 'filters' // a saved home has a default distance
  const canClear = f.cats.length > 0 || f.free || f.hidden || f.setting !== null || f.when !== 'any' || f.inc.length > 0 || f.fame.length > 0 || (f.parts ?? []).length > 0 || (f.days ?? []).length > 0 // 10/16: include words and fame too; 10/17: time of day, weekdays
  if (!canWiden && !canClear) return null
  return (
    <div className="mt-4 flex flex-wrap gap-2">
      {canWiden && <button type="button" onClick={onWiden} className={buttonClass('primary', 'md')}>{f2('browse.widen')}</button>}
      {canClear && <button type="button" onClick={onClear} className={buttonClass('secondary', 'md')}>{f2('browse.clear_filters')}</button>}
    </div>
  )
}
